export default __webpack_public_path__ + "static/media/logo-gsk.3899bec9.png";